import React, { useState, useEffect } from 'react';
import { useStore } from '@store';
import { observer } from 'mobx-react-lite';
import { DateFilter } from '@components';
import { addCommas, removeNonNumeric, dateConvert } from '@helper';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
const PayoffDetail = () => {
    const {
        PayoffDetailStore: {
            payoffDetails,
            updateData,
            startDate,
            endDate,
            getPayoffDetails,
            reset,
            cancelRepayment,
        },
    } = useStore();
    const [defaultValue, setDefaultValue] = useState('0');
    const statusBtn = {
        0: { text: '成功', color: 'btn-warning', title: '已完成還款' },
        1: {
            text: '失敗',
            color: 'btn-danger',
            title: '',
        },
        2: {
            text: '取消',
            color: 'btn-cancel2',
            title: '預約單取消',
        },
        3: {
            text: '處理中',
            color: 'btn-processing',
            title: '1. 分戶帳現金還款扣款中\n2. 一般帳戶現金還款審核是否收到款項中',
        },
        4: {
            text: '預約中',
            color: 'btn-reserve',
            title: '1. 預約單，營業日09:00轉成處理中\n2. 賣股還款09:00-14:40，為預約單，14:40轉成處理中',
        },
    };
    // const [pageData, setPageData] = useState([]);
    useEffect(() => {
        getPayoffDetails(defaultValue, startDate, endDate);
        // setPageData(payoffDetails);
    }, [defaultValue, startDate, endDate]);
    useEffect(() => {
        return () => {
            reset({ startDate: '', endDate: '' });
        };
    }, []);

    // const handlePageClick = async e => {
    //     // console.log(e.selected);
    //     const currentPage = e.selected + 1;
    //     // console.log(currentPage);
    //     await getPayoffDetails();
    // };
    return (
        <div>
            <h6 className="title fs-22 fw-bolder mb-3">還款明細</h6>
            <div className="filter-info d-sm-flex flex-nowrap justify-content-between align-items-center mb-2">
                <DateFilter
                    defaultValue={defaultValue}
                    data={payoffDetails}
                    setDefaultValue={setDefaultValue}
                    updateData={updateData}
                />
            </div>
            <div className="overflow-auto fs-15 scrol_sty">
                <table
                    cellSpacing={0}
                    className="table table_sty fix-last fs-6"
                >
                    <thead>
                        <tr>
                            <th>還款申請日期</th>
                            <th>止息日期</th>
                            <th>申請書編號</th>
                            <th className="text-end">還款金額</th>
                            <th className="text-end">利息</th>
                            <th className="text-end">淨收付金額</th>
                            <th>還款種類</th>
                            {/* <th>申請方式</th> */}
                            <th>賣股還款張數</th>
                            <th className="fix">狀態</th>
                        </tr>
                    </thead>
                    <tbody>
                        {payoffDetails.map(
                            (
                                {
                                    repayMentDate,
                                    restDate,
                                    applyType,
                                    bhno,
                                    applicationNumber,
                                    repayMentAmount,
                                    repayMentInterest,
                                    netPayAmount,
                                    repayMentAccountType,
                                    collateralNumber,
                                    status,
                                    failReason,
                                },
                                index
                            ) => {
                                return (
                                    <tr key={`payoffDetails ${index}`}>
                                        <th>{dateConvert(repayMentDate)}</th>
                                        <td>{dateConvert(restDate)}</td>
                                        <td>{applicationNumber}</td>
                                        <td>
                                            <div className="text-end">
                                                <span>$</span>
                                                {addCommas(
                                                    removeNonNumeric(
                                                        repayMentAmount
                                                    )
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="text-end">
                                                <span>$</span>
                                                {addCommas(
                                                    removeNonNumeric(
                                                        repayMentInterest
                                                    )
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="text-end">
                                                <span>-$</span>
                                                {addCommas(
                                                    removeNonNumeric(
                                                        netPayAmount
                                                    )
                                                )}
                                            </div>
                                        </td>
                                        <td>
                                            <span className="border border-info rounded text-info fs-15">
                                                {repayMentAccountType === 's'
                                                    ? '賣 股'
                                                    : '現 金'}
                                            </span>
                                        </td>
                                        {/* <td>{applyType}</td> */}
                                        <td>
                                            {!collateralNumber
                                                ? '-'
                                                : collateralNumber}
                                        </td>
                                        <td className="fix cur-pointer">
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    failReason ? (
                                                        <Tooltip>
                                                            {failReason}
                                                        </Tooltip>
                                                    ) : (
                                                        <Tooltip>
                                                            {statusBtn[
                                                                status
                                                            ].title
                                                                .split('\n')
                                                                .map(
                                                                    (
                                                                        line,
                                                                        idx
                                                                    ) => {
                                                                        return (
                                                                            <p
                                                                                key={`line ${idx}`}
                                                                            >
                                                                                {
                                                                                    line
                                                                                }
                                                                            </p>
                                                                        );
                                                                    }
                                                                )}
                                                        </Tooltip>
                                                    )
                                                }
                                            >
                                                <span
                                                    className={`btn-state btn fs-15 text-white cur-pointer ${statusBtn[status].color}`}
                                                >
                                                    {statusBtn[status].text}
                                                </span>
                                            </OverlayTrigger>
                                        </td>
                                        {/* <td>
                                            <button
                                                onClick={async () => {
                                                    await cancelRepayment(
                                                        applicationNumber
                                                    );
                                                }}
                                            >
                                                退
                                            </button>
                                        </td> */}
                                    </tr>
                                );
                            }
                        )}
                    </tbody>
                </table>
            </div>
            {/* <ReactPaginate
                previousLabel={'＜'}
                nextLabel={'＞'}
                pageCount={Math.ceil(payoffDetails.length / 10) || 1}
                onPageChange={handlePageClick}
                breakLabel={'…'}
                containerClassName={
                    'pagination align-items-center justify-content-center mt-2'
                }
                pageClassName={'page-item'}
                pageLinkClassName={'page-link'}
                previousClassName={'page-item'}
                nextClassName={'page-item'}
                breakClassName={'page-item'}
                breakLinkClassName={'page-link'}
                activeClassName={'active'}
            /> */}
        </div>
    );
};

export default observer(PayoffDetail);
